module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"DeleteSuccess":"La section a bien été supprimée","CreateSuccess":"La section a bien été ajoutée","EditSuccess":"La section a bien été modifiée"}}')
  delete Component.options._Ctor
}
